import Callback from "./Callback.en";
import EmailSignUp from "./EmailSignUp.en";
import SessionStart from "./SessionStart.en";
import SignIn from "./SignIn.en";
import SignUp from "./SignUp.en";
import SubscriptionConfirmation from "./SubscriptionConfirmation.en";
import VerifyEmailDialog from "./VerifyEmailDialog.en";
import ZoomOauthCallback from "./ZoomOauthCallback.en";

export default {
	Callback,
	EmailSignUp,
	SessionStart,
	SignIn,
	SignUp,
	SubscriptionConfirmation,
	VerifyEmailDialog,
	ZoomOauthCallback,
};
